import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DocumentHeader, DocumentFooter, HeaderFormData, FooterFormData } from './document-header-footer.interface';

@Injectable({
    providedIn: 'root',
})
export class DocumentHeaderFooterService {
    private basePath = environment.interop.basePath;

    // Headers URLs
    private headersListUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.list;
    public headersListDTUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.listDT;
    private headersListActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.listActive;
    private headersDefaultUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.default;
    private headersFindUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.find;
    private headersStoreUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.store;
    private headersUpdateUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.update;
    private headersDeleteUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.delete;
    private headersSetDefaultUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.setDefault;
    private headersToggleActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.toggleActive;
    private headersUploadImageUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentHeaders.uploadImage;

    // Footers URLs
    private footersListUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.list;
    public footersListDTUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.listDT;
    private footersListActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.listActive;
    private footersDefaultUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.default;
    private footersFindUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.find;
    private footersStoreUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.store;
    private footersUpdateUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.update;
    private footersDeleteUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.delete;
    private footersSetDefaultUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.setDefault;
    private footersToggleActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.toggleActive;
    private footersUploadImageUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.uploadImage;
    private footersPreviewPaginationUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.documentFooters.previewPagination;

    constructor(private http: HttpClient) {}

    // ==================== HEADERS ====================

    getHeadersList(): Observable<any> {
        return this.http.get(this.headersListUrl);
    }

    getHeadersListActive(): Observable<any> {
        return this.http.get(this.headersListActiveUrl);
    }

    getDefaultHeader(): Observable<any> {
        return this.http.get(this.headersDefaultUrl);
    }

    findHeader(id: number): Observable<any> {
        return this.http.get(this.headersFindUrl + id);
    }

    storeHeader(payload: HeaderFormData): Observable<any> {
        return this.http.post(this.headersStoreUrl, payload);
    }

    updateHeader(payload: HeaderFormData): Observable<any> {
        return this.http.put(this.headersUpdateUrl, payload);
    }

    deleteHeader(id: number): Observable<any> {
        return this.http.delete(this.headersDeleteUrl + id);
    }

    setHeaderDefault(id: number): Observable<any> {
        return this.http.put(this.headersSetDefaultUrl + id, {});
    }

    toggleHeaderActive(id: number): Observable<any> {
        return this.http.put(this.headersToggleActiveUrl + id, {});
    }

    uploadHeaderImage(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('image', file);
        return this.http.post(this.headersUploadImageUrl, formData);
    }

    // ==================== FOOTERS ====================

    getFootersList(): Observable<any> {
        return this.http.get(this.footersListUrl);
    }

    getFootersListActive(): Observable<any> {
        return this.http.get(this.footersListActiveUrl);
    }

    getDefaultFooter(): Observable<any> {
        return this.http.get(this.footersDefaultUrl);
    }

    findFooter(id: number): Observable<any> {
        return this.http.get(this.footersFindUrl + id);
    }

    storeFooter(payload: FooterFormData): Observable<any> {
        return this.http.post(this.footersStoreUrl, payload);
    }

    updateFooter(payload: FooterFormData): Observable<any> {
        return this.http.put(this.footersUpdateUrl, payload);
    }

    deleteFooter(id: number): Observable<any> {
        return this.http.delete(this.footersDeleteUrl + id);
    }

    setFooterDefault(id: number): Observable<any> {
        return this.http.put(this.footersSetDefaultUrl + id, {});
    }

    toggleFooterActive(id: number): Observable<any> {
        return this.http.put(this.footersToggleActiveUrl + id, {});
    }

    uploadFooterImage(file: File): Observable<any> {
        const formData = new FormData();
        formData.append('image', file);
        return this.http.post(this.footersUploadImageUrl, formData);
    }

    previewPagination(format: string): Observable<any> {
        return this.http.post(this.footersPreviewPaginationUrl, { format });
    }
}
